// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomButton_root__2CqJB"};